import { useState, useEffect, createContext } from 'react';
import { login, register, logOut, requestPasswordReset, fetchCurrentUser, loginWithGoogle, resendVerification } from '../auth';

const AuthContext = createContext(null);

function AuthProvider({ children }) {
    const [profile, setProfile] = useState(null);
    const [authLoading, setAuthLoading] = useState(true);

    // Restore session from httpOnly cookie on mount
    useEffect(() => {
        fetchCurrentUser()
            .then(res => setProfile(res.data ?? null))
            .catch(() => setProfile(null))
            .finally(() => setAuthLoading(false));
    }, []);

    const handleLogin = async (email, password) => {
        const res = await login(email, password);
        setProfile(res.data);
        return res.data;
    };

    const handleRegister = async (email, password) => {
        await register(email, password);
        // Account created but not yet verified — no profile set until email confirmed
    };

    const handleGoogleLogin = async (access_token) => {
        const res = await loginWithGoogle(access_token);
        setProfile(res.data);
        return res.data;
    };

    const handleLogOut = async () => {
        try { await logOut(); } catch {}
        setProfile(null);
        window.location.href = '/';
    };

    const isLoggedIn = () => profile != null;

    const queryIsUserAdmin = async () => {
        if (!profile) return 0;
        return profile.is_admin || 0;
    };

    return (
        <AuthContext.Provider value={{
            profile,
            authLoading,
            login: handleLogin,
            loginGoogle: handleGoogleLogin,
            register: handleRegister,
            logOut: handleLogOut,
            requestPasswordReset,
            resendVerification,
            isLoggedIn,
            queryIsUserAdmin,
            setProfile,
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export { AuthContext, AuthProvider };
